import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'reactstrap';
import InputMask from 'react-input-mask';
import { Link } from 'react-router-dom';
import { TranslateExt, Translate } from '../contexts/LanguageContext';



export function TransferOptionUrl() {
    let transferOption = window.location.pathname.replace('/', '');

    if (transferOption.indexOf('/'))
        transferOption = transferOption.split('/')[1];

    return transferOption;
}


export const Rules = (props) => {

    let rules = props.Items.map(item => (
        <li key={item}>
           <i className="fas fa-genderless p-1 rounded text-warning"></i> {TranslateExt(item)}
        </li>
    ));

    return (
        props.Items.length > 0 ?
        <ul className="list-unstyled tra-transfer__rules">
        {rules}
    </ul>
    :
    "")
              
       
}

Rules.prototype = {
    Items: PropTypes.array.isRequired
};
Rules.defaultProps = {
    Items: []
};


export const PaymentConfirm = (props) => {

    let formItems = props.Form.map(item => (
        <div className="form-group row ml-3" key={item.title}>
            <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{TranslateExt(item.title)}</label>
            <label htmlFor="example-text-input" className="col-sm-5 col-form-label">{item.value}</label>         
        </div>
    ));

    return (
        <div className="col-md-12">
            <h4 className="mt-0 header-title m-b-20 mt-4">{TranslateExt(props.Title)}</h4>
            {formItems}
            {props.Success === false ?
                (<div className="form-group row ml-3">
                    <label htmlFor="example-text-input" className="col-sm-2 col-form-label"></label>
                    <div className="col-sm-12">
                        <button type="button" className="btn btn-lg btn-warning" onClick={(e) => props.Cancel(e)}><i className="fas fa-chevron-left"></i> &nbsp; {TranslateExt(props.CancelButtonTitle)}</button>
                        <button type="button" className="btn btn-lg btn-info float-right" onClick={(e) => props.Confirm(e)}>{props.ConfirmButtonTitle} &nbsp; <i className="fas fa-chevron-right"></i></button>
                    </div>
                </div>) :
                (<div className="form-group row ml-4 mr-4">
                    <div className="alert alert-success mb-0 col-md-12" role="alert">
                        <h4 className="alert-heading font-18"><i className="far fa-check-circle"></i> {TranslateExt("Request Received!")}</h4>
                        <p>{TranslateExt("Your withdrawal request has been received. It will be processed as soon as possible.")}</p>
                        <Link className="btn btn-lg btn-info mb-3" to={props.Deposit ? "/deposit" : "/withdrawal"}><i className="fas fa-chevron-left"></i>{TranslateExt("&nbsp; Back to "+(props.Deposit ? "Deposit" : "Withdrawal")+" Page")}</Link>
                    </div>
                </div>)}
        </div>
    )
}


PaymentConfirm.prototype = {
    Form: PropTypes.array.isRequired,
    Title: PropTypes.string.isRequired,
    CancelButtonTitle: PropTypes.string.isRequired,
    ConfirmButtonTitle: PropTypes.string.isRequired,
    Cancel: PropTypes.func,
    Confirm: PropTypes.func
};
PaymentConfirm.defaultProps = {
    Form: [],
    Title: "Confirm Payment Form",
    CancelButtonTitle: "Cancel Deposit",
    ConfirmButtonTitle: "Confirm Deposit",
    Success: false
};

export const CardType = (number) => {

    function GetCardType(number) {
        // visa
        var re = new RegExp("^4");
        if (number.match(re) != null)
            return "visa";

        // Mastercard 
        // Updated for Mastercard 2017 BINs expansion
        if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
            return "mastercard";

        // AMEX
        re = new RegExp("^3[47]");
        if (number.match(re) != null)
            return "amex";

        return "creditcard";
    }

    return GetCardType(number)
}


export class CreditCardFrom extends Component {

    constructor(props) {
        super(props)

        this.state = {
            cvvTip: false,
            cardIcon: "creditcard",
            creditCard: {
                cardNumber: 0,
                expMonth: 0,
                expYear: 0,
                cvv: 0
            }
        }
    }
    onChangeCreditCard(e) {

        let tempCreditCard = this.state.creditCard;
        let value = e.target.value;

        tempCreditCard.cardNumber = value;

        this.setState({
            cardIcon: CardType(value),
            creditCard: tempCreditCard
        }, () => this.props.onChange(e, this.state.creditCard));

    }
    onChangeForm(e, key) {

        let tempCreditCard = this.state.creditCard;

        tempCreditCard[key] = e.target.value;

        this.setState({
            creditCard: tempCreditCard
        }, () => this.props.onChange(e, this.state.creditCard));

    }
    render() {
        return (
            <Fragment>
                <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="far fa-credit-card"></i>&nbsp; {TranslateExt("Card Information")}</h4>
                <div className="form-group row ml-3">
                    <label htmlFor="amount" className="col-sm-2 col-form-label">Card Number</label>
                    <div className="col-sm-5">
                        <div className="input-group">
                            <InputMask className="form-control" id="cardNumber" mask="9999 9999 9999 9999" maskChar={null} placeholder="1234 5678 9012 3456" onChange={(e) => this.onChangeCreditCard(e)} />
                            <div className="input-group-append hide">
                                <button type="button" className="input-group-text pt-0 pb-0 bg-white">
                                    <img src={"/assets/images/" + this.state.cardIcon + ".png"} height="30" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group row ml-3">
                    <label htmlFor="amount" className="col-sm-2 col-form-label">{TranslateExt("Expiration Date")}</label>
                    <div className="col-sm-5">
                        <div className="row">
                            <div className="col-sm-6">
                                <select className="form-control" id="expMonth" required onChange={(e) => this.onChangeForm(e, "expMonth")}>
                                    <option value="" disabled selected hidden>{Translate("Month")}</option>
                                    <option value="01">01</option>
                                    <option value="02">02</option>
                                    <option value="03">03</option>
                                    <option value="04">04</option>
                                    <option value="05">05</option>
                                    <option value="06">06</option>
                                    <option value="07">07</option>
                                    <option value="08">08</option>
                                    <option value="09">09</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                </select>
                            </div>
                            <div className="col-sm-6">
                                <select className="form-control" id="expYear" required onChange={(e) => this.onChangeForm(e, "expYear")}>
                                    <option value="" disabled selected hidden>{Translate("Year")}</option>
                                    <option value="19">19</option>
                                    <option value="20">20</option>
                                    <option value="21">21</option>
                                    <option value="22">22</option>
                                    <option value="23">23</option>
                                    <option value="24">24</option>
                                    <option value="25">25</option>
                                    <option value="26">26</option>
                                    <option value="27">27</option>
                                    <option value="28">28</option>
                                    <option value="29">29</option>
                                    <option value="30">30</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group row ml-3">
                    <label htmlFor="amount" className="col-sm-2 col-form-label">CVV / CVV2</label>
                    <div className="col-sm-5">
                        <div className="input-group">
                            <input className="form-control" type="password" id="cvv" onChange={(e) => this.onChangeForm(e, "cvv")} placeholder="●●●" />
                            <div className="input-group-append">
                                <button type="button" className="input-group-text bg-white" id="cvvTip">
                                    <i className="fas fa-question font-13"></i>
                                </button>
                                <Tooltip placement="right" className="ccToolTip" isOpen={this.state.cvvTip} target="cvvTip" toggle={() => this.setState({ cvvTip: !this.state.cvvTip })}>
                                    <img src="/assets/images/cvv.png" width="200" className="pr-3" alt="" />
                                </Tooltip>
                            </div>
                        </div>

                    </div>
                </div>
            </Fragment>
        )
    }
}



export const Currencies = (props) => {

    let currencies = props.Items.map(item => (
        <option key={item} value={item}>{item}</option>
    ));

    return (
        <select className="form-control notranslate" id="currency" onChange={(e) => props.onChange(e)}>
            {currencies}
        </select>)
}

Currencies.prototype = {
    Items: PropTypes.array.isRequired
};
Currencies.defaultProps = {
    Items: []
};